module.exports = __webpack_public_path__ + "img/25.e874ad32.png";